import ProvidersES from '@/services/ProvidersES';

export const initProviders = ({ commit, getters, dispatch }, force) => {
    if (!getters.initialized || getters.isExpired() || force) {
        return dispatch('fetchProviders')
            .then(() => commit('SET_INITIALIZED', true))
            .then(() => dispatch('refreshExpirationDate'));
    }
}

export const refreshExpirationDate = ({ commit }) => {
    commit('SET_EXPIRATION_DATE')
}

export const fetchProviders = ({ commit }, payload) => {
    commit('SET_LOADING', true);
    return ProvidersES.getProviders()
        .then(response => response.data)
        .then(data => commit('SET_PROVIDERS', ProvidersES.mapSource(data)))
        .finally(() => commit('SET_LOADING', false));
}
